import {createContext} from '@lit-labs/context';
export const DefaultPersonalizationsContext = createContext<string[]>(
  'default-personalizations-context'
);
